import { call, put, select, take } from 'redux-saga/effects';

import request from '../request';
import requests from '../requests';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import i18n from '../../../i18n';
import { removeAccessToken } from '../../../utils/access-token-storage';

export function* initializeCore() {
  const currentConfig = yield select(selectors.selectConfig); // TODO: add boolean selector?

  let config;
  if (!currentConfig) {
    ({ item: config } = yield call(api.getConfig)); // TODO: handle error

    yield put(actions.initializeCore.fetchConfig(config));
  }

  const {
    user,
    board,
    users,
    projects,
    projectManagers,
    boards,
    boardMemberships,
    labels,
    lists,
    cards,
    cardMemberships,
    cardLabels,
    tasks,
    attachments,
    activities,
    notifications,
    pointSystems,
    cardPointData,
    cardPointAdvancedData,
    listReportData,
    contentCardDefaults,
    contentTypes,
  } = yield call(requests.fetchCore); // TODO: handle error

  console.log('[initializeCore] fetchCore result:', {
    hasBoard: !!board,
    boardId: board?.id,
    pointSystemsCount: pointSystems?.length || 0,
    cardPointDataCount: cardPointData?.length || 0,
    cardPointAdvancedDataCount: cardPointAdvancedData?.length || 0,
    listReportDataCount: listReportData?.length || 0,
    contentCardDefaultsCount: contentCardDefaults?.length || 0,
    contentTypesCount: contentTypes?.length || 0,
    cardsCount: cards?.length || 0,
    listsCount: lists?.length || 0,
  });

  yield call(changeCoreLanguage, user.language || 'ru');

  yield put(
    actions.initializeCore(
      user,
      board,
      users,
      projects,
      projectManagers,
      boards,
      boardMemberships,
      labels,
      lists,
      cards,
      cardMemberships,
      cardLabels,
      tasks,
      attachments,
      activities,
      notifications,
      pointSystems,
    ),
  );

  const pointSystemForBoard =
    board && pointSystems && pointSystems.length > 0
      ? pointSystems.find((ps) => String(ps.projectId) === String(board.projectId))
      : null;

  console.log('[initializeCore] pointSystemForBoard:', {
    boardId: board?.id,
    projectId: board?.projectId,
    found: !!pointSystemForBoard,
    pointSystem: pointSystemForBoard,
  });

  // Обрабатываем cardPointData для детекции закрытости задач
  if (cardPointData && cardPointData.length > 0 && board) {
    if (pointSystemForBoard) {
      console.log('[initializeCore] dispatch CardPointData -> ORM:', {
        pointSystemId: pointSystemForBoard.id,
        count: cardPointData.length,
      });
      for (const item of cardPointData) {
        if (item) {
          yield put(actions.fetchCardPointData.success(item.cardId, pointSystemForBoard.id, item));
        }
      }
    } else {
      console.warn('[initializeCore] skip CardPointData: pointSystemForBoard not found', {
        boardId: board?.id,
        samplePointSystems: (pointSystems || []).slice(0, 3),
      });
    }
  }

  // Обрабатываем cardPointAdvancedData для подсчета суммы баллов
  if (cardPointAdvancedData && cardPointAdvancedData.length > 0 && board) {
    if (pointSystemForBoard) {
      // Группируем по cardId для обработки
      const cardPointAdvancedDataByCardId = {};
      cardPointAdvancedData.forEach((item) => {
        if (!cardPointAdvancedDataByCardId[item.cardId]) {
          cardPointAdvancedDataByCardId[item.cardId] = [];
        }
        cardPointAdvancedDataByCardId[item.cardId].push(item);
      });

      // Обрабатываем каждую карточку
      console.log('[initializeCore] dispatch CardPointAdvancedData -> ORM:', {
        pointSystemId: pointSystemForBoard.id,
        cardsWithAdvanced: Object.keys(cardPointAdvancedDataByCardId).length,
        itemsTotal: cardPointAdvancedData.length,
      });
      for (const cardId of Object.keys(cardPointAdvancedDataByCardId)) {
        const items = cardPointAdvancedDataByCardId[cardId];
        yield put(actions.fetchCardPointAdvancedData.success(cardId, pointSystemForBoard.id, items));
      }
    } else {
      console.warn('[initializeCore] skip CardPointAdvancedData: pointSystemForBoard not found', {
        boardId: board?.id,
        samplePointSystems: (pointSystems || []).slice(0, 3),
      });
    }
  }

  // Обрабатываем listReportData для отображения статуса закрытия месяца
  if (listReportData && listReportData.length > 0) {
    console.log('[initializeCore] dispatch ListReportData -> ORM:', {
      count: listReportData.length,
      closedCount: listReportData.filter((x) => x?.closed === true).length,
    });
    for (const item of listReportData) {
      if (item) {
        yield put(actions.fetchListReportData.success(item.listId, item));
      }
    }
  }

  // Обрабатываем contentCardDefaults для подсчета суммы баллов
  if (contentCardDefaults && contentCardDefaults.length > 0 && board) {
    if (pointSystemForBoard) {
      console.log('[initializeCore] dispatch ContentCardDefaults -> ORM:', {
        pointSystemId: pointSystemForBoard.id,
        count: contentCardDefaults.length,
      });
      yield put(actions.fetchContentCardDefaults.success(pointSystemForBoard.id, contentCardDefaults));
    } else {
      console.warn('[initializeCore] skip ContentCardDefaults: pointSystemForBoard not found', {
        boardId: board?.id,
        samplePointSystems: (pointSystems || []).slice(0, 3),
      });
    }
  }

  if (contentTypes && contentTypes.length > 0 && pointSystemForBoard) {
    yield put(actions.fetchContentTypes.success(pointSystemForBoard.id, contentTypes));
  }

  // Загружаем DampingCoefficients для расчета коэффициентов при инициализации
  if (board && pointSystems && pointSystems.length > 0) {
    if (pointSystemForBoard) {
      console.log('[initializeCore] Найден pointSystem, загружаем DampingCoefficients для pointSystemId:', pointSystemForBoard.id);
      const dampingCoefficientsService = yield import('./damping-coefficients');
      // Передаем pointSystemId напрямую, так как selectPointSystemForCurrentBoard может не найти его сразу после initializeCore
      yield call(dampingCoefficientsService.fetchDampingCoefficientsInCurrentBoard, pointSystemForBoard.id);
    } else {
      console.log('[initializeCore] pointSystem не найден для board.id:', board.id);
    }
  } else {
    console.log('[initializeCore] board или pointSystems отсутствуют, board:', board, 'pointSystems:', pointSystems);
  }
}

export function* changeCoreLanguage(language) {
  if (language === null) {
    yield call(i18n.detectLanguage);
    yield call(i18n.loadCoreLocale);
    yield call(i18n.changeLanguage, i18n.resolvedLanguage);
  } else {
    yield call(i18n.loadCoreLocale, language);
    yield call(i18n.changeLanguage, language);
  }
}

export function* logout(invalidateAccessToken = true) {
  yield call(removeAccessToken);

  if (invalidateAccessToken) {
    yield put(actions.logout.invalidateAccessToken());

    try {
      yield call(request, api.deleteCurrentAccessToken);
    } catch (error) {} // eslint-disable-line no-empty
  }

  yield put(actions.logout());
  yield take();
}

export default {
  initializeCore,
  changeCoreLanguage,
  logout,
};
